<template>
    <div class="step">
        <h2 class="group-title">What are the details?</h2>
        <app-input type="text"
                   id="camp-name"
                   name="camp-name"
                   v-model="campName"
                   v-validate="'required|max:200'"
                   placeholder="e.g. Master Chef Jr"
                   label="Camp name">
        </app-input>
        <div class="row">
            <div class="col-12 col-xl-6">
                <dropdown label="Instructor"
                          name="instructor-id"
                          footer-action-label="Add new Instructor"
                          not-found-message="Oh no! We can’t find anyone with that name :|"
                          not-exists-message="There any instructors added yet"
                          :max-height=160
                          :data-list="instructors"
                          :format-callback="formatInstructor"
                          :default-value="instructors && instructors.find(instructor => instructor.id === form.camp.instructorId)"
                          @footer-action="openInstructorModal"
                          @selected="setInstructorId"
                >
                </dropdown>
            </div>
            <div class="col-12 col-xl-6">
                <dropdown label="Locations"
                          name="location-id"
                          footer-action-label="Add new Location"
                          not-found-message="Oh no! We can’t find anything with that name :|"
                          not-exists-message="There any locations added yet"
                          :max-height=160
                          :data-list="locationsList"
                          :format-callback="formatLocation"
                          :default-value="locations && locations.find(location => location.id === form.camp.locationId)"
                          @footer-action="openLocationModal"
                          @selected="setLocationId"
                >
                </dropdown>
            </div>
        </div>
        <h2 class="group-title mt-4">Camp Description</h2>
        <text-editor class="editor"
                     height="250px"
                     name="description"
                     tag-name="textarea"
                     v-validate="{ required: true, max: 8000 }"
                     v-model="campDescription"
                     @input="campDescription = $event">
        </text-editor>
        <div class="error">{{ errors.first('description') }}</div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import * as Mutations from '@/store/modules/camp-form/mutations';
    import { FormMixin } from '@/mixins/FormMixin';
    import { EditorMixin } from '@/mixins/EditorMixin';
    import { ActivityLocationFormMixin } from '@/mixins/ActivityLocationFormMixin';
    import { ActivityInstructorFormMixin } from '@/mixins/ActivityInstructorFormMixin';

    export default {
        name: 'Step1',
        components: {
            VueSlider:  () => import('vue-slider-component'),
            Choice:     () => import('@/components/controls/Choice'),
            Dropdown:   () => import('@/components/controls/Dropdown'),
            AppInput:   () => import('@/components/controls/AppInput'),
            TextEditor: () => import('@/components/controls/TextEditor'),
        },
        mixins: [FormMixin, EditorMixin, ActivityLocationFormMixin, ActivityInstructorFormMixin],
        computed: {
            ...mapGetters({
                instructors: 'instructors',
                locations: 'allLocations',
                form: 'campCreationForm',
                enrollType: 'campCreationType'
            }),
            locationsList() {
                this.locations && this.locations.length && this.locations.map(location => {
                    location.zoom
                        ? location.img = require('../../../../assets/img/zoom.svg')
                        : location.img = require('../../../../assets/img/map-pin.svg');

                    return location;
                });

                this.locations && this.locations.length && this.locations.push(this.locations.splice(this.locations.findIndex(location => location.zoom && location.name === 'Zoom web conference'), 1)[0]);

                return this.locations;
            },
            campName: {
                get() {
                    return this.form.camp.campName;
                },
                set(value) {
                    this.setCampName(value);
                }
            },
            campDescription: {
                get() {
                    return this.form.camp.description;
                },
                set(value) {
                    this.setCampDescription(value);
                }
            },
        },
        watch: {
            formValid: {
                handler() {
                    this.setValid(this.formValid);
                },
                immediate: true
            }
        },
        methods: {
            ...mapMutations({
                setCampName: Mutations.CAMP_FORM_SET_CAMP_NAME,
                setCampDescription: Mutations.CAMP_FORM_SET_CAMP_DESCRIPTION,
                setInstructorId: Mutations.CAMP_FORM_SET_INSTRUCTOR_ID,
                setLocationId: Mutations.CAMP_FORM_SET_LOCATION_ID,
                setValid: Mutations.CAMP_FORM_SET_FORM_VALID,
                setType: Mutations.CAMP_FORM_SET_TYPE
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../assets/colors";

    .step {
        padding: 50px 92px;
        background: $White;
        width: 100%;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
        @media screen and (max-width: 1200px){
            padding: 45px 50px 50px;
        }
        @media screen and (max-width: 991px){
            padding: 40px 30px 45px;
        }
        @media screen and (max-width: 767px){
            padding: 40px 20px;
        }

        /deep/ .form-group {
            margin-bottom: 20px;
        }

        .group-title {
            margin: 26px 0 40px;
            &:first-of-type {
                margin: 0 0 30px;
            }
        }

        label {
            margin-bottom: 0;
            font-family: Asap;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            color: $WhiteGrey;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/Step1.vue